/**
 * Shared helpers for order payload shaping on print routes (packing slip, shipping label).
 */

/** Mutates archive API orders into the same recipient/warehouse shape as live orders. */
export function applyOrdersArchiveRecipientWarehouse(responseData: any): void {
    if (responseData == null) {
        return;
    }
    const list = toOrdersArray(responseData);
    list.forEach((order: any) => {
        order.recipient = {
            name: order.recipient_name,
            address: order.recipient_address,
            city: order.recipient_city,
            country: order.recipient_country,
            state: order.recipient_state,
            zip_code: order.recipient_zip_code,
            phone: order.recipient_phone,
            email: order.recipient_email,
        };
        if (order.warehouse_name != null || order.warehouse_id != null) {
            order.warehouse = {
                name: order.warehouse_name,
                id: order.warehouse_id,
            };
        }
    });
}

/** Normalizes API `orderDetail` (null | T | T[]) to a flat array for mapping. */
export function toOrdersArray(orderDetail: unknown): any[] {
    if (orderDetail == null) {
        return [];
    }
    return Array.isArray(orderDetail) ? orderDetail : [orderDetail];
}
